import React from 'react';
import { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import authStore from 'modern/authStore';
import { observer } from 'mobx-react-lite';

export const AuthProvider = observer(({ children }: { children: ReactNode }) => {
	const navigate = useNavigate();

	const isAuthenticated = authStore.isAuthenticated;

	useEffect(() => {
		if (!isAuthenticated) {
			navigate('/booker/auth');
		}
	}, [navigate, isAuthenticated]);

	return <>{children}</>;
});
